
import { http } from '../../core';
import Config from "../../app.config";
const RequestbaseURL = http.create({ baseURL: Config.BASE_API });

export function eventInfo(id) {
  return RequestbaseURL.get('/fault/v1/event/info', { id } )
}

export function editEvent(params) {
  return RequestbaseURL.post('/fault/v1/event/edit', params)
}

export function closeEvent(params) {
  return RequestbaseURL.post('/fault/v1/event/close', params)
}

export function departmentList() {
  return RequestbaseURL.get('/fault/v1/department/list')
}

export default {
    eventInfo,
    editEvent,
    closeEvent,
    departmentList
}